/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SendFeedbackRequest = {
    text?: string;
    isPublic?: boolean;
    status?: SendFeedbackRequest.status;
    category?: SendFeedbackRequest.category;
    public?: boolean;
};
export namespace SendFeedbackRequest {
    export enum status {
        OPEN = 'OPEN',
        IN_PROGRESS = 'IN_PROGRESS',
        RESOLVED = 'RESOLVED',
        ARCHIVED = 'ARCHIVED',
    }
    export enum category {
        GENERAL = 'GENERAL',
        BUG = 'BUG',
        FEATURE = 'FEATURE',
        IMPROVEMENT = 'IMPROVEMENT',
        OTHER = 'OTHER',
    }
}

